import { AfterViewInit, ChangeDetectorRef, Component } from '@angular/core';
import { HelperService } from './shared/services/helper.service';
import { BrowserSupportService } from './shared/services/browser-support.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements AfterViewInit {
  title = 'breeze';
  isSupported: boolean;

  constructor(
    private readonly cdRef: ChangeDetectorRef,
    private helperService: HelperService,
    private browserSupportService: BrowserSupportService
  ) {
    this.isSupported = this.browserSupportService.isSupported();
  }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
  }

  ngAfterViewInit(): void {
    document
      .querySelector('.button-1')
      ?.addEventListener('mouseenter', this.greenButtonHoverHandler);

    document
      .querySelector('.action.button-1')
      ?.addEventListener('mouseout', this.greenButtonUnhoverHandler);

    this.cdRef.detectChanges();
    this.helperService.cookieConsentInit();
  }

  greenButtonHoverHandler() {
    document.querySelector('.action.button-1')?.classList.add('animateHover');
    document
      .querySelector('.action.button-1')
      ?.classList.remove('animateUnhover');
  }

  greenButtonUnhoverHandler() {
    document.querySelector('.action.button-1')?.classList.add('animateUnhover');
    document
      .querySelector('.action.button-1')
      ?.classList.remove('animateHover');
  }
}
